import { render, staticRenderFns } from "./SquareButton.vue?vue&type=template&id=4f7136ef&scoped=true&lang=pug"
import script from "./SquareButton.vue?vue&type=script&lang=ts"
export * from "./SquareButton.vue?vue&type=script&lang=ts"
import style0 from "./SquareButton.vue?vue&type=style&index=0&id=4f7136ef&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7136ef",
  null
  
)

export default component.exports